import { Link, NavLink, Outlet } from "react-router-dom";
import { Logo } from "@/components/ui/Logo";
import { cn } from "@/lib/cn";

const nav = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/process", label: "Process" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function PublicLayout() {
  return (
    <div className="relative min-h-screen">
      <div className="pointer-events-none fixed inset-0 bg-grid-faint bg-[size:60px_60px] opacity-[0.35]" />
      <header className="relative z-10 border-b border-ink-700/60 bg-ink-950/70 backdrop-blur">
        <div className="container-x flex h-16 items-center justify-between">
          <Link to="/"><Logo /></Link>
          <nav className="hidden md:flex items-center gap-8">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  cn(
                    "font-mono text-xs uppercase tracking-[0.2em] transition",
                    isActive ? "text-brand-blue" : "text-silver-200 hover:text-silver-50",
                  )
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
           <a href="https://ai.infinimarketing.com/auth" className="btn-ghost hidden sm:inline-flex">Client Portal</a>
            <Link to="/contact" className="btn-primary">Book Strategy</Link>
          </div>
        </div>
      </header>
      <main className="relative z-10"><Outlet /></main>
      <footer className="relative z-10 mt-24 border-t border-ink-700/60 bg-ink-950/80">
        <div className="container-x py-12 grid gap-8 md:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-4 text-sm text-silver-300 max-w-xs">
              Build trustworthy brands. Generate leads. Measure everything.
            </p>
          </div>
          <div>
            <div className="eyebrow mb-3">Company</div>
            <ul className="space-y-2 text-sm text-silver-200">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/process">Process</Link></li>
              <li><Link to="/services">Services</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-3">Clients</div>
            <ul className="space-y-2 text-sm text-silver-200">
<li><a href="https://ai.infinimarketing.com/auth">Client Portal</a></li>              <li><Link to="/contact">Support</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-3">Contact</div>
            <p className="text-sm text-silver-200">hello@infinimarketing.com</p>
            <p className="text-sm text-silver-300 mt-1">Mon–Fri · 9a–6p</p>
          </div>
        </div>
        <div className="border-t border-ink-700/60">
          <div className="container-x py-4 flex items-center justify-between text-xs text-silver-300 font-mono uppercase tracking-widest">
            <span>© {new Date().getFullYear()} INFINI Marketing</span>
            <span>v0.1 · preview build</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
